import React, { useState, useRef, useEffect } from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const LANGUAGES = [
  { code: 'fr', label: 'Français' },
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'de', label: 'Deutsch' },
  { code: 'pt', label: 'Português' }
];

export const LanguageSelector = ({ compact = false }) => {
  const { language, setLanguage } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    document.addEventListener('touchstart', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('touchstart', handleClick);
    };
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1 text-velvet_text-secondary hover:text-velvet_text-accent transition-colors text-xs sm:text-sm font-bold uppercase tracking-wider bg-white/10 rounded-full px-2 sm:px-3 py-1 sm:py-1.5"
        data-testid="language-toggle"
      >
        <Globe size={14} />
        {!compact && <span>{language.toUpperCase()}</span>}
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 z-50">
          <div className="glass rounded-xl py-2 min-w-[130px] border border-white/10 shadow-xl">
            {LANGUAGES.map(lang => (
              <button
                key={lang.code}
                onClick={() => { setLanguage(lang.code); setOpen(false); }}
                className={`w-full text-left px-4 py-2 text-sm transition-colors ${
                  language === lang.code
                    ? 'text-purple-light font-medium'
                    : 'text-velvet_text-secondary hover:text-velvet_text-primary hover:bg-white/5'
                }`}
                data-testid={`lang-select-${lang.code}`}
              >
                {lang.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
